// extracted by mini-css-extract-plugin
module.exports = {"button":"AfishaTag_button__dW19c","icon":"AfishaTag_icon__awWqb"};